import { Row, Col, Pagination, Button, Form } from "react-bootstrap";
import BTable from "react-bootstrap/Table";

import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
// import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useEffect, useState } from "react";
import { left, right } from "../../assets/img";

export function Table({
  columns,
  data,
  setPageno,
  pagecount,
  show,
  pageno,
  color = "#000",
}) {
  const navigate = useNavigate();
  const [pagenumber, setPagenumber] = useState(1);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,

    globalFilter,
    setGlobalFilter,

    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: pageno ? pageno - 1 : 0, pageSize: 10000 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  useEffect(() => {
    setPagenumber(pageIndex + 1);
  }, [pageIndex]);
  // console.log(pageCount,"page count",canPreviousPage,canNextPage);

  return (
    <div className="table-design">
      {/* <Row className="">
        <Col className="">
          <div className="d-flex ac-je ps-2 mt-2">
            <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
          </div>
        </Col>
      </Row> */}
      <BTable
        size="sm"
        responsive
        {...getTableProps()}
        className=" table-border  table mb-0"
      //  variant="dark"
      >
        <thead className="fixed-header  ">
          {headerGroups.map((headerGroup, ind) => (
            <tr
              className=" thfiled table_header"
              {...headerGroup.getHeaderGroupProps()}
              key={ind}
            >
              {headerGroup.headers.map((column, indx) => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th
                  className=" text-center    "
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  key={indx}
                  style={{ border: "none" }}
                >
                  <h4 className="text-center f3 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18  p-3 white  text-nowrap">
                    {column.render("Header")}
                  </h4>

                  <span>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <span className="feather icon-arrow-down text-muted float-right" />
                      ) : (
                        <span className="feather icon-arrow-up text-muted float-right" />
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr className="text-start f2" {...row.getRowProps()} key={i}>
                {row.cells.map((cell, ind) => {
                  const isClickable = [].includes(cell.column.Header);

                  const { name, mobileno } = row.original;
                  // console.log("Clicked Client:", cell.column, isClickable);
                  return (
                    <td
                      style={{
                        border: "none",
                        color: color,
                        cursor: isClickable ? "pointer" : "default",
                        borderRight: "2px solid #d9d9d9 !important",
                      }}
                      className="text-center f4 fs-xs-14 fs-sm-12 fs-md-14 fs-lg-15 fs-xl-16 fs-xxl-18 mt-2 gray2 list-data"
                      {...cell.getCellProps()}
                      key={ind}
                      onClick={() => {
                        if (isClickable) {
                          // Log ClientId, Name, Phone
                          // const { ClientID, name, mobileno } = row.original;
                          // console.log("Clicked Client:", {
                          //   name,
                          //   mobileno,
                          //   ClientID,
                          // });

                          navigate("/client-report");
                        }
                      }}
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </BTable>

      {show && !pagecount && (
        <Row className="justify-content-between table-show  p-1 w-100 bg-primary2">
          <Col className="d-flex ac-jb pagination_box  ">
            <p className="px-1 mb-0 f2 fs-xs-14 fs-sm-15 fs-md-16 fs-lg-17 fs-xl-18 fs-xxl-20">
              Total Pages 10
            </p>
            <Pagination className=" pointer mb-0 d-flex ac-js">
              {pagenumber > 1 && (
                // <img
                //   src={left}
                //   width={20}
                //   height={22}
                //   alt=""
                //   onClick={() => {
                //     setPagenumber((pagenumber) =>
                //       pagenumber > 1 ? pagenumber - 1 : 1
                //     );
                //   }}
                // />
                <PlayArrowIcon
                  className="left-arrow"
                  onClick={() => {
                    setPagenumber((pagenumber) =>
                      pagenumber > 1 ? pagenumber - 1 : 1
                    );
                  }}
                />
              )}
              {/* <button className=" f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 form-control   text-center">1</button> */}
              <input
                type="number"
                min={1}
                max={pageCount}
                style={{ width: "25px", height: "25px" }}
                className="form-control1   text-center f2 fs-xs-14 fs-sm-15 fs-md-16 fs-lg-17 fs-xl-18 fs-xxl-20"
                value={pagenumber}
                onChange={(e) => {
                  if (!Number(e.target.value)) {
                    setPagenumber(e.target.value);
                    return;
                  }
                  if (e.target.value > pageCount) {
                    gotoPage(pageCount - 1);
                    setPagenumber(pageCount);
                    return;
                  }
                  const page = e.target.value ? Number(e.target.value) - 1 : 0;
                  gotoPage(page);
                  setPagenumber(e.target.value);
                }}
              />
              {/* 
              <img
                src={right}
                width={20}
                height={22}
                alt=""
                onClick={() => {
                  setPagenumber(pagenumber + 1);
                }}
              /> */}
              <PlayArrowIcon
                className="right-arrow"
                onClick={() => {
                  setPagenumber(pagenumber + 1);
                }}
              />
            </Pagination>
          </Col>
        </Row>
      )}
    </div>
  );
}
